// 美国时间：11月25日，PST时间 0:00
// 北京时间：11月25日，北京时间 15:00

  var data=new Date('2022-11-25 15:00:00');
  var daysFromNow = (data.getTime() / 1000);
  var hasFlipdownClassName =  document.getElementsByClassName("image-container")[0].classList;
  var flipdown = new FlipDown(daysFromNow, {
      headings: ['Days', 'Hours', 'Minutes'], // 配置多语言
  })
    .start()
    .ifEnded(() => {
        // 倒计时结束后，移除DOM
        var flipdown = document.querySelector('#flipdown');
        var flipdownTit = document.querySelector('.flipdown-tit');
        if(flipdown) {
          flipdownTit.remove();
          flipdown.remove();
          hasFlipdownClassName.remove('hasFlipdown')
        }
    });